// Environment and development utilities
export const isDevelopment = () => {
  return process.env.REACT_APP_NODE_ENV === 'development' || 
         process.env.NODE_ENV === 'development' ||
         process.env.REACT_APP_DEV_MODE === 'true';
};

export const isLocalhost = () => {
  return window.location.hostname === 'localhost' || 
         window.location.hostname === '127.0.0.1';
};

export const isMockAuthEnabled = () => {
  return process.env.REACT_APP_MOCK_AUTH === 'true';
};

export const isDebugMode = () => {
  return process.env.REACT_APP_DEBUG_MODE === 'true';
};

export const shouldBypassAuth = () => {
  // Triple-check: development mode + localhost + explicit enable + not production
  const isProductionBuild = process.env.NODE_ENV === 'production';
  const hasProductionUrl = window.location.hostname.includes('vercel.app') || 
                          window.location.hostname.includes('intellegacy');
  
  // Absolutely never bypass in production environments
  if (isProductionBuild || hasProductionUrl) {
    return false;
  }
  
  // Only allow bypass in development AND localhost AND when explicitly enabled
  return isDevelopment() && isLocalhost() && isMockAuthEnabled();
};

export const getApiUrl = () => {
  // If explicitly set, use that
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  
  // Auto-detect environment based on hostname
  const hostname = window.location.hostname;
  
  // Localhost - use local backend or staging
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'http://localhost:3002';
  }
  
  // Staging environments
  if (hostname.includes('staging') || 
      hostname.includes('develop') ||
      hostname.includes('preview')) {
    return 'https://staging-api.intellegacy.app';
  }
  
  // Production
  return 'https://api.intellegacy.app';
};

export const debugLog = (message, data = null) => {
  if (isDebugMode()) {
    console.log(`🔍 DEBUG: ${message}`, data);
  }
};

export const securityLog = (message, data = null) => {
  if (isDevelopment()) {
    console.log(`🔐 SECURITY: ${message}`, data);
  }
};
